import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-clinic-charcoal text-clinic-bg" data-testid="footer">
      <div className="container-clinic section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://customer-assets-wrfwihn1.emergentagent.net/job_0b41d704-a68a-4dc5-aa3c-437daaaec2be/artifacts/01612048b5d59fe8_Kavish-Logo-Icon-SurgicalPine.png"
                alt="Kavish Maheshwari"
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-clinic-accent font-body text-sm leading-relaxed max-w-xs">
              Consultant-led plastic, reconstructive, and aesthetic surgery. 
              Ethical, evidence-based care with discretion.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-caption text-clinic-accent mb-6">Navigation</h4>
            <ul className="space-y-3">
              {[
                { path: '/about', label: 'About' },
                { path: '/treatments', label: 'Treatments' },
                { path: '/before-after', label: 'Before & After' },
                { path: '/scar-guide', label: 'Scar Guide' },
                { path: '/consultation', label: 'Consultation' },
                { path: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-clinic-accent hover:text-white transition-colors duration-300 text-sm font-body"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Treatments */}
          <div>
            <h4 className="text-caption text-clinic-accent mb-6">Treatments</h4>
            <ul className="space-y-3">
              {[
                { path: '/treatments/body-contouring', label: 'Body Contouring' },
                { path: '/treatments/breast-surgery', label: 'Breast Surgery' },
                { path: '/treatments/non-surgical', label: 'Non-Surgical' },
                { path: '/treatments/skin-cancer', label: 'Skin Cancer' },
                { path: '/treatments/laser-treatments', label: 'Laser Treatments' },
                { path: '/treatments/hand-surgery', label: 'Hand Surgery' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-clinic-accent hover:text-white transition-colors duration-300 text-sm font-body"
                    data-testid={`footer-treatment-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-caption text-clinic-accent mb-6">Locations</h4>
            <ul className="space-y-3">
              <li className="text-sm font-body">
                <span className="text-white">The Private Clinic</span>
                <span className="text-clinic-accent block">Harley Street &middot; Northampton &middot; Birmingham</span>
              </li>
              <li className="text-sm font-body">
                <span className="text-white">Tonic Weight Loss Surgery</span>
                <span className="text-clinic-accent block">Ashby &middot; Luton</span>
              </li>
              <li className="text-sm font-body">
                <span className="text-white">Hale Medical Centre</span>
                <span className="text-clinic-accent block">Manchester</span>
              </li>
              <li className="text-sm font-body">
                <span className="text-white">3 Counties Clinic</span>
                <span className="text-clinic-accent block">Bedford</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-clinic-stone/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-clinic-stone text-xs font-body">
              © {currentYear} Kavish Maheshwari. All rights reserved.
            </p>
            <div className="flex gap-6">
              <span className="text-clinic-stone text-xs font-body">
                Mr Kavish Maheshwari MBBS, MS, MRCS, MCh, FRCS (Plast) &middot; GMC: 7680988
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
